import { render } from "./settings.vue?vue&type=template&id=3ddebeb3&scoped=true"
import script from "./settings.vue?vue&type=script&lang=js"
export * from "./settings.vue?vue&type=script&lang=js"

import "./settings.vue?vue&type=style&index=0&id=3ddebeb3&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ddebeb3"],['__file',"src/components/settings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ddebeb3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ddebeb3', __exports__)) {
    api.reload('3ddebeb3', __exports__)
  }
  
  module.hot.accept("./settings.vue?vue&type=template&id=3ddebeb3&scoped=true", () => {
    api.rerender('3ddebeb3', render)
  })

}


export default __exports__